import React from 'react';
import WorkerTable from "./Component/Worker/WorkerTable";

const WorkerManagement = () => {
    return (
        <div>
            <WorkerTable/>
        </div>
    )
}

export default WorkerManagement;
